import React, { Component } from 'react';
import Bar from '../common/new_graph/bar';
import Buttons from './buttons';
import Table from './table';
import LoadingModal from '../common/loadingModal';
import moment from 'moment';

const DataGraph = data => {
  const arrayEvolution = [];
  let open = 0;
  let closedoverdue = 0;
  let closed = 0;
  let overdue = 0;
  data.forEach(item => {
    item.distribution.forEach(graph => {
      switch (graph.risk) {
        case 'OPEN':
          open = graph.value;
          break;
        case 'OVERDUE':
          overdue = graph.value;
          break;
        case 'CLOSEDOVERDUE':
          closedoverdue = graph.value;
          break;
        case 'CLOSED':
          closed = graph.value;
          break;
        default:
        // code block
      }
    });
    arrayEvolution.push({
      date: moment(item.date).format('MMM DD'),
      'Desv. abiertas': overdue + open,
      'Desv. cerradas': closed,
      'Desv. cerradas vencidas': closedoverdue
    });
  });

  return arrayEvolution;
};

const Modal = props => {
  let loading = false;
  let loadingClass = '';
  let dataGraph;

  if (props.loadingModalEvolution || props.loadingModalEvolutionFilter || props.loadingModalTable) {
    loading = true;
    loadingClass = 'loading';
  } else {
    loading = false;
    loadingClass = '';
    dataGraph = DataGraph(props.datosModalEvolution.evolution);
  }

  return (
    <div
      data-close="ok"
      onClick={props.handleModal}
      className={props.modal ? `container-modal` : `container-modal hide`}
    >
      <section className="module-title modal-title special">
        <h2>Desviaciones nivel de fatiga acumulada</h2>
        <a>
          <i data-close="ok" onClick={props.handleModal} className="fas fa-times-circle" />
        </a>
      </section>
      <div
        id="modal-nfa"
        onScroll={props.handleScroll}
        className={
          props.modalRight ? `box-modal start ${loadingClass}` : `box-modal ${loadingClass}`
        }
      >
        {!loading ? (
          <section>
            <div className="modal-gestionador">
              <div className="modal-gestionador-graph">
                <Bar data={dataGraph} />
              </div>
              <div className="modal-gestionador-info">
                <div className="list">
                  <ul>
                    <li className="open">desv. abiertas</li>
                    <li className="closed">desv. cerradas</li>
                    <li className="closedoverdue">desv. cerradas vencidas</li>
                  </ul>
                </div>
                <div>
                  <h4>{props.datosModalEvolution.tasks}</h4>
                  <h5>tareas</h5>
                </div>
              </div>
            </div>
            <Buttons
              handleFilter={props.handleFilter}
              filter={props.filter}
              language={props.language}
              datos={props.datosModalEvolutionFilter}
              input={props.input}
              handleChange={props.handleChange}
              handleChangeReset={props.handleChangeReset}
            />
            <Table
              language={props.language}
              pag={props.pag}
              count={props.count}
              loadingTable={props.tableNoLoading}
              datos={props.datosModalTable}
              handleClickTask={props.handleClickTask}
            />
          </section>
        ) : (
          <LoadingModal height="modal-nfa" />
        )}
      </div>
    </div>
  );
};

export default Modal;



// WEBPACK FOOTER //
// ./source/client/components/detail_nfa/modal.jsx